export default __webpack_public_path__ + "static/media/partner_logo_pexip.d862a082.svg";